<p-panel [collapsed]="true" [toggleable]="true">
  <ng-template pTemplate="header">
    <div class="filter-card-header">
      <span class="filter-icon"><i class="fa fa-history"></i></span>
      <span class="filter-card-title">Change history</span>
    </div>
  </ng-template>
  <div *ngIf="unavailable" class="empty-state">
    <i aria-hidden="true" class="fa fa-lock"></i>
    <div class="empty-state-title">Change history unavailable</div>
    <div class="empty-state-subtitle">You are not allowed to read this user's audit trail.</div>
  </div>
  <p-table *ngIf="!unavailable" (onLazyLoad)="loadLazy($event)" [lazy]="true" [loading]="loading"
           [paginator]="true" [rows]="pageSize" [totalRecords]="totalItems" [value]="auditEntries">
    <ng-template pTemplate="loadingicon">
      <p-progressSpinner [style]="{width: '40px', height: '40px'}" animationDuration="1.2s"
                         strokeWidth="4"></p-progressSpinner>
    </ng-template>
    <ng-template pTemplate="header">
      <tr>
        <th style="width: 16%">When</th>
        <th style="width: 14%">Action</th>
        <th style="width: 48%">Changes</th>
        <th style="width: 22%">Changed by</th>
      </tr>
    </ng-template>
    <ng-template let-entry pTemplate="body">
      <tr>
        <td class="when-cell">{{ entry.createdAt | date:'MMM d, y H:mm' }}</td>
        <td><span class="action-badge action-badge--{{entry.action}}">{{ auditUtilsService.getActionLabel(entry.action) }}</span></td>
        <td class="changes-cell">
          <div *ngIf="entry.changes?.length; else noChange" class="change-list">
            <div *ngFor="let change of entry.changes" class="change-row">
              <ng-container *ngIf="auditUtilsService.isRoleChange(entry); else fieldDiff">
                <span class="change-field">{{ auditUtilsService.getRoleChangeLabel(entry) }}:</span>
                <span class="change-new">{{ auditUtilsService.getRoleName(change) }}</span>
              </ng-container>
              <ng-template #fieldDiff>
                <span *ngIf="auditUtilsService.isPasswordChange(change); else valueDiff" class="change-field">Password changed</span>
              </ng-template>
              <ng-template #valueDiff>
                <span class="change-field">{{ auditUtilsService.getFieldLabel(change.field) }}</span>
                <span class="change-old">{{ auditUtilsService.getDisplayedValue(change.old) }}</span>
                <i aria-hidden="true" class="fa fa-long-arrow-right change-arrow"></i>
                <span class="change-new">{{ auditUtilsService.getDisplayedValue(change.new) }}</span>
              </ng-template>
            </div>
          </div>
          <ng-template #noChange><span class="change-empty">-</span></ng-template>
        </td>
        <td class="actor-cell">
          <span *ngIf="entry.actor === 'restricted'" class="actor-restricted">Restricted</span>
          <span *ngIf="entry.actor !== 'restricted'">{{ entry.actor || 'system' }}</span>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="4">
          <div class="empty-state">
            <i aria-hidden="true" class="fa fa-history"></i>
            <div class="empty-state-title">No recorded change yet</div>
            <div class="empty-state-subtitle">Changes to this user will appear here.</div>
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>
</p-panel>
